import React from 'react';

import ConsultantTileSmall, {
  IConsultantTileSmall,
} from '../components/static/ConsultantTileSmall';

export default (tiles: IConsultantTileSmall[], filterIds: number[]) =>
  tiles
    .filter(tile => filterIds.length === 0 || filterIds.includes(tile.id))
    .map(tile => <ConsultantTileSmall key={tile.id} {...tile} />);
